/**
 * Filename: 入口文件
 * Created Date:2021/9/6
 * Author: pyh
 *
 * Copyright (c) 2021 Your Company
 */
import Vue from 'vue';
import App from './App.vue';
import './plugins/index'; // 引用插件
import './plugins/expend'; // 引用扩展
import router from './router/index';
import store from './store';
import '@/assets/css/index.scss';
import i18n from './language';
import config from './config';
import server from './services/serve';
import utils from './utils/index';
import storeage from './utils/storeage';
Vue.prototype.$utils = utils;
Vue.prototype.$sg = storeage;
Vue.prototype.$config = config;
Vue.prototype.$server = server;

//引入video.js文件
import Videojs from 'video.js';
import 'videojs-flash';
import 'video.js/dist/video-js.css';


import '@/icons/index'; // icon

Vue.prototype.$video = Videojs;


new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
